import React from "react";
import { Pagination } from "react-bootstrap";

export function PaginationControl({ from = 0, numHits = 0, pageSize = 20, onPage }) {
  const numPages = Math.ceil(numHits / pageSize);
  const page = Math.floor(from / pageSize) + 1;
  const range = [page - 3, page - 2, page - 1, page, page + 1, page + 2, page + 3].filter(
    (n) => n >= 1 && n <= numPages
  );
  const onClick = (n) => () => {
    onPage((n - 1) * pageSize, n, pageSize);
    window.scrollTo(0, 0);
  };

  return (
    <section className="text-xs-center mt-2">
      <Pagination className="justify-content-center" size="sm">
        {range.map((n, key) => (
          <Pagination.Item key={n} active={n === page} onClick={onClick(n)}>
            {n}
          </Pagination.Item>
        ))}
      </Pagination>
    </section>
  );
}
